import dayjs from 'dayjs';

export const CHRISTMAS_YEAR = !dayjs().month() ? dayjs().year() - 1 : dayjs().year();

export const CHRISTMAS_TRANSLATION_VALUES = {
	year: CHRISTMAS_YEAR,
	nextYear: CHRISTMAS_YEAR + 1,
} as const;
